export const FETCH_ARTICLES_WISSEN_REQUEST = 'FETCH_ARTICLES_WISSEN_REQUEST';
export const FETCH_ARTICLES_WISSEN_SUCCESS = 'FETCH_ARTICLES_WISSEN_SUCCESS';
export const FETCH_ARTICLES_WISSEN_FAILURE = 'FETCH_ARTICLES_WISSEN_FAILURE';
export const FETCH_ARTICLES_WISSEN_CLEAN_UP = 'FETCH_ARTICLES_WISSEN_CLEAN_UP';
export const UPDATE_WISSEN_PAGE_START_PARAM = 'UPDATE_WISSEN_PAGE_START_PARAM';
